/* eslint-disable react-hooks/exhaustive-deps */

import React, { useLayoutEffect, useState } from "react";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import {
  Layout,
  Card,
  Table,
  Tag,
  Input,
  Space,
  Spin,
  DatePicker,
  Button,
} from "antd";

import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  ReloadOutlined,
} from "@ant-design/icons";

import dayjs from "dayjs";

import { getAPI } from "../../utils/common";

import { SMART_PRICE, SMART_PRICE_CHANGE_HISTORY } from "../../constants/api";

function SmartPriceChangeHistory() {
  const { Content } = Layout;

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  const [filteredData, setFilteredData] = useState([]);

  const [search, setSearch] = useState("");

  useLayoutEffect(() => {
    getHistory();
  }, []);

  const getHistory = () => {
    setLoading(true);

    getAPI(
      SMART_PRICE_CHANGE_HISTORY,

      (res) => {
        if (res.status === true) {
          let list = [];

          if (Array.isArray(res.data)) {
            list = res.data;
          } else if (Array.isArray(res.data.data)) {
            list = res.data.data;
          }

          setData(list);

          setFilteredData(list);
        }

        setLoading(false);
      },

      () => {
        setLoading(false);
      },

      {},
    );
  };

  const handleSearch = (value) => {
    setSearch(value);

    let result = data.filter((item) =>
      item.room?.room_name

        ?.toLowerCase()

        .includes(value.toLowerCase()),
    );

    setFilteredData(result);
  };

  const columns = [
    {
      title: "Room",

      render: (row) => (
        <>
          <b>{row.room?.room_name}</b>

          <br />

          <small>{row.room?.room_no}</small>
        </>
      ),
    },
    {
      title: "Type",

      dataIndex: "change_type",

      render: (v) => <Tag color="blue">{v}</Tag>,
    },

    {
      title: "Old Price",

      dataIndex: "old_price",

      render: (value) => <Tag>₹ {value}</Tag>,
    },

    {
      title: "New Price",

      dataIndex: "new_price",

      render: (value, row) => (
        <Tag
          color={
            Number(row.new_price) > Number(row.old_price) ? "green" : "red"
          }
        >
          ₹ {value}
        </Tag>
      ),
    },

    {
      title: "Change",

      render: (row) => {
        if (Number(row.new_price) > Number(row.old_price))
          return (
            <Tag color="green">
              <ArrowUpOutlined />
              Increase
            </Tag>
          );

        return (
          <Tag color="red">
            <ArrowDownOutlined />
            Decrease
          </Tag>
        );
      },
    },

    {
      title: "Reason",

      dataIndex: "reason",

      render: (value) => {
        try {
          let reasons = JSON.parse(value);

          return (
            <Space direction="vertical">
              {reasons.slice(0, 2).map((item, index) => (
                <Tag key={index}>
                  {item.factor}: {item.reason}
                </Tag>
              ))}
            </Space>
          );
        } catch (e) {
          return value || "-";
        }
      },
    },

    {
      title: "Changed By",

      dataIndex: "changed_by",
    },

    {
      title: "Effective Date",

      dataIndex: "effective_date",

      render: (value) => (value ? dayjs(value).format("DD MMM YYYY") : "-"),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title="Smart Price Change History"
          extra={
            <Space>
              <Input
                placeholder="Search Room"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
                style={{
                  width: 250,
                }}
              />

              <DatePicker />

              <Button icon={<ReloadOutlined />} onClick={getHistory}>
                Refresh
              </Button>
            </Space>
          }
        >
          <Spin spinning={loading}>
            <Table
              columns={columns}
              dataSource={filteredData}
              rowKey={(row, index) => index}
              pagination={{
                pageSize: 10,
              }}
              scroll={{
                x: 1200,
              }}
            />
          </Spin>
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default SmartPriceChangeHistory;
